<template>
<svg
  t="1640016074048"
  class="icon"
  viewBox="0 0 1024 1024"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  p-id="3997"
  width="64"
  height="64"
>
  <path
    d="M299.87 512L512 299.87 724.13 512 512 724.13 299.87 512z m88.5975 3.75L515.75 643.025 643.025 515.75 515.75 388.475 388.475 515.75z m-225.2775-3.735l78.9825 78.9825L204.49999999 628.67 87.83 512 204.49999999 395.33l37.68750001 37.6875-78.9975 78.9975z m348.795 348.795L433.0025 781.8275 395.33 819.50000001 512 936.17 628.67 819.50000001l-37.6875-37.68750001-78.9975 78.9975zM512 163.205l78.9825 78.9825L628.67 204.49999999 512 87.83 395.33 204.49999999l37.6875 37.68750001L512 163.205zM860.795 512L781.8125 433.0175 819.50000001 395.33 936.17 512 819.50000001 628.67l-37.68750001-37.6875L860.795 512z"
    p-id="3998"
  />
</svg>
</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconAdaptAuto',
} as DefineComponent
</script>